import WineCard from "@/components/WineCard";
import { useLanguage } from "@/context/LanguageContext";

export default function CatalogResults({ wines, loading }) {
  const { t } = useLanguage();

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={`skeleton-${i}`} className="glass-card rounded-sm p-5 h-52 animate-pulse">
            <div className="h-3 w-16 bg-white/5 rounded mb-4" />
            <div className="h-5 w-3/4 bg-white/5 rounded mb-2" />
            <div className="h-3 w-1/2 bg-white/5 rounded" />
          </div>
        ))}
      </div>
    );
  }

  if (wines.length === 0) {
    return (
      <div className="text-center py-20" data-testid="no-results">
        <p className="font-display text-xl text-white/40 mb-2">{t.noWinesFound}</p>
        <p className="font-body text-sm text-white/25">{t.tryAdjusting}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5" data-testid="wine-grid">
      {wines.map((wine) => <WineCard key={wine.id} wine={wine} />)}
    </div>
  );
}
